import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../../../global.service';
import {EventsService} from '../../events.service';
import {AppSettings} from '../../../app.settings';
import {FacebookService, InitParams, UIResponse, UIParams, LoginOptions, LoginResponse} from "ngx-facebook";
import {NotificationsService} from "angular2-notifications";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-honor',
  templateUrl: './honor.component.html',
  styleUrls: ['./honor.component.css']
})
export class HonorComponent implements OnInit {
  language: any;
  langChosen: string = 'en';
  AppSettings: any;

  constructor(private notify: NotificationsService, public eventService: EventsService, public globalService: GlobalService , private titleService:Title) {
    this.AppSettings = AppSettings;
    this.titleService.setTitle('honor')

  }

  ngOnInit() {
    // set default language
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./lang/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('./lang/en.json');
      }
    }
  }


  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.langChosen = value;
      this.language = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }

  pageChanged(page) {
    this.eventService.Event.value.are_participants_loading = true;
    this.eventService.getParticipants(this.eventService.Event.value.tournaments.data[0].code, page).subscribe(res => {
      this.eventService.Event.next({
        ...this.eventService.Event.value,
        'participants': res.participants
      });
      this.eventService.Event.value.are_participants_loading = false;
    });
  }

}
